import { render, staticRenderFns } from "./SuggestPartApplication.vue?vue&type=template&id=df660e7e"
import script from "./SuggestPartApplication.ts?vue&type=script&lang=ts&external"
export * from "./SuggestPartApplication.ts?vue&type=script&lang=ts&external"
import style0 from "./SuggestPartApplication.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports